import React from 'react'
// libs
import styled from 'styled-components'
// components
import SortableTreeTheme from './Theme'
import SortableTree, { getTreeFromFlatData } from 'react-sortable-tree'
// utils
import { isFunction, isEmpty } from 'lodash/fp'
import { formatTree, getNodeKey, getKey, getParentKey } from 'utils/tree'
// views
import { PlaceholderWrapper } from 'themes/views/tree'

// styled
export const TreeWrapper = styled.div`
  height: 100%;
`

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  margin: 0;

  display: flex;
  flex-direction: column;
`

const Tree = ({
  source,
  sourceTree,
  isLoading,
  onMoveNode,
  placeholder,
  generateActionHandlers,
  generateNodeProps,
  synchronizeTree,
  synchronizeTreeFunc,
  normalizeData,
  refetch,
  ...rest
}) => {
  const data = isEmpty(sourceTree)
    ? getTreeFromFlatData({
        flatData: source,
        getKey,
        getParentKey,
        rootKey: null
      })
    : sourceTree

  const [tree, setTree] = React.useState(data)

  React.useEffect(() => setTree(normalizeData ? normalizeData(data) : data), [source, sourceTree])

  if (isEmpty(sourceTree) && isEmpty(source)) {
    return isLoading ? null : <PlaceholderWrapper>{placeholder}</PlaceholderWrapper>
  }

  // methods
  const handleMoveNode = async ({ treeData }) => {
    const formattedTree = formatTree(treeData)

    if (isFunction(synchronizeTree)) {
      await synchronizeTree(formattedTree)
      console.warn('[Tree]: synchronizeTree is deprecated, please use synchronizeTreeFunc')
    }
    if (isFunction(synchronizeTreeFunc)) {
      await synchronizeTreeFunc({ setTree, formattedTree, tree })
    }

    if (isFunction(refetch)) {
      await refetch()
    }

    if (isFunction(onMoveNode)) {
      onMoveNode({ treeData, setTree })
    }
  }

  const handleExpandNode = ({ treeData }) => {
    const formattedTree = formatTree(treeData)

    if (isFunction(synchronizeTree)) {
      synchronizeTree(formattedTree)
      console.warn('[Tree]: synchronizeTree is deprecated, please use synchronizeTreeFunc')
    }
    if (isFunction(synchronizeTreeFunc)) {
      synchronizeTreeFunc({ setTree, tree: treeData, formattedTree })
    }
  }

  const onChange = (tree) => setTree(tree)

  const handleGenerateNodeProps = (...args) => {
    let nodeProps = {}

    if (generateActionHandlers) {
      nodeProps = {
        ...generateActionHandlers({ setTree: setTree, tree: tree })
      }
    }

    if (generateNodeProps) {
      nodeProps = {
        ...nodeProps,
        ...generateActionHandlers(...args)
      }
    }

    return { ...nodeProps, tree, setTree }
  }

  const canDrag = ({ node }) => !node.noDragging

  const canDrop = ({ nextParent }) => !nextParent || !nextParent.noChildren

  return (
    <Wrapper>
      <TreeWrapper>
        <SortableTree
          onMoveNode={handleMoveNode}
          onVisibilityToggle={handleExpandNode}
          theme={SortableTreeTheme}
          treeData={tree}
          onChange={onChange}
          getNodeKey={getNodeKey}
          canDrag={canDrag}
          canDrop={canDrop}
          generateNodeProps={handleGenerateNodeProps}
          {...rest}
        />
      </TreeWrapper>
    </Wrapper>
  )
}

// Tree.propTypes = {
//   source: array,
//   refetch: func,
//   isLoading: bool,
//   placeholder: node,
//   /**
//    * @deprecated please use synchronizeTreeFunc
//    */
//   synchronizeTree: func,
//   synchronizeTreeFunc: func,
//   generateNodeProps: func,
//   generateActionHandlers: func
// }

export default Tree
